import { type HTMLAttributes } from "react";
import { cn } from "./utils/cn";

export interface RoadmapPhaseProps extends HTMLAttributes<HTMLElement> {
  numeral: string; // "I" | "II" | "III" | "IV"
  noun: string;
  tagline: string;
  body: string;
  bullets: string[];
  pullQuote: string;
}

export const RoadmapPhase = ({
  numeral,
  noun,
  tagline,
  body,
  bullets,
  pullQuote,
  className,
  ...rest
}: RoadmapPhaseProps) => (
  <section className={cn("hui-roadmap-phase", className)} {...rest}>
    <div className="hui-roadmap-phase__header">
      <span className="hui-roadmap-phase__numeral">{numeral}</span>
      <h2 className="hui-roadmap-phase__noun">
        {noun}
        <span className="hui-roadmap-phase__tagline"> — {tagline}</span>
      </h2>
    </div>
    <p className="hui-roadmap-phase__body">{body}</p>
    {bullets.length > 0 && (
      <ul className="hui-roadmap-phase__bullets">
        {bullets.map((b) => (
          <li key={b}>{b}</li>
        ))}
      </ul>
    )}
    <blockquote className="hui-roadmap-phase__quote">{pullQuote}</blockquote>
  </section>
);
